import React from 'react';
import { Center, Heading, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ArcButton } from '../../../../common/components/ArcButton';
import { SlidingAnimationPageBase } from '../../../../common/components/SlidingAnimationPageBase';
import { useParamBackUrl } from '../../../../common/hooks/use-param-back-url';
import { createLocationPermissionIcon } from '../../../../styles/create-location-permission-icon';
import { requestLocationPermission } from './location-permission-helpers';

export function LocationInfo() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const backURL = useParamBackUrl('/sites/list');
  const LocationPermissionIcon = createLocationPermissionIcon();

  const handleContinue = async () => {
    const granted = await requestLocationPermission();

    if (granted) {
      navigate('../first_time_hardware_configuration', { replace: true });
    } else {
      navigate('../location_required_error', { replace: true });
    }
  };

  return (
    <SlidingAnimationPageBase includeTopNav title={t('Common.device setup')} backURL={backURL}>
      <Center flexDirection="column" px={3} textAlign="center">
        <LocationPermissionIcon data-testid="location-permission-image" h="300px" w="300px" />

        <Heading mt={2}>{t('Location.allow location access')}</Heading>
        <Text mt={1}>{t('Location.use location services to make setup')}</Text>
        <ArcButton onClick={handleContinue} mt={8} w={'80%'} arcColor="#3DCD57">
          {t('Common.continue')}
        </ArcButton>
      </Center>
    </SlidingAnimationPageBase>
  );
}
